import UniqueIdGenerator from "../utils/uniqueIdGenerator.js";

const TYPE_ID = require("../../../src-client-lib/api/type-ids.js");
const STATUS = require("../../../src-client-lib/api/request/constants.js");
const ApiErrorFactory = require("./apiErrorFactory.js");


class DataSetService {
  createDataset(dataset) {
    return new Promise((resolve, reject) => {
      smashClient.createDataset(dataset, (response) => {
        if (response.typeId === TYPE_ID.CreateDatasetResponse) {
          if (response.status === 0) {
            resolve(response.dataset);
          } else {
            reject();
          }
        } else {
          throw ApiErrorFactory.TypeError(TYPE_ID.DataProfileCreated, response.typeId);
        }
      });
    });
  }

  createDataProfile(dataProfile) {
    return new Promise((resolve, reject) => {
      smashClient.createDataProfile(dataProfile, (response) => {
        if (response.typeId === TYPE_ID.DataProfileCreated) {
          resolve(response);
        } else {
          reject();
        }
      });
    });
  }

  createDatasetLicense(license) {
    return new Promise((resolve, reject) => {
      smashClient.createDatasetLicense(license, (response) => {
        if (response.typeId === TYPE_ID.DatasetLicenseCreated) {
          resolve(response);
        } else {
          reject();
        }
      });
    });
  }

  getOnlySubscribedDataSetsByName(searchString, pagingOption) {
    return new Promise((resolve, reject) => {
      let payload = {
        searchString: searchString,
        pageNumber: pagingOption.pageNumber,
        pageSize: pagingOption.pageSize
      };
      smashClient.getOnlySubscribedDataSetsByName(payload, (response => {
        resolve(response.data);
      }));
    });
  }

  getOnlyUnsubscribedDataSetsByName(searchString, pagingOption) {
    return new Promise((resolve, reject) => {
      let payload = {
        searchString: searchString,
        pageNumber: pagingOption.pageNumber,
        pageSize: pagingOption.pageSize
      };
      smashClient.getOnlyUnsubscribedDataSetsByName(payload, (response => {
        resolve(response.data);
      }));
    });
  }

  getDataSetsByName(searchString, pagingOption) {
    return new Promise((resolve, reject) => {
      let payload = {
        searchString: searchString,
        pageNumber: pagingOption ? pagingOption.pageNumber : undefined,
        pageSize: pagingOption ? pagingOption.pageSize : undefined
      };
      smashClient.getDataSetsByName(payload, (response => {
        resolve(response.data);
      }));
    });
  }

  getDataBankDataSetsByName(searchString, pagingOption = {}) {
    return new Promise((resolve, reject) => {
      let payload = {
        searchString: searchString,
        pageNumber: pagingOption.pageNumber,
        pageSize: pagingOption.pageSize
      };
      smashClient.getDataBankDatasetByNameOrDescription(payload, (response => {
        resolve(response.data);
      }));
    });
  }

  findDataSetByName(datasetName, callback) {
    smashClient.getDataSetsByName({
      searchString: datasetName
    }, callbackWrapper);

    function callbackWrapper(response) {
      var dataset = null;

      for (var i = 0; i < response.data.length; i++) {
        var name = response.data[i].name.toLowerCase();
        if (name === datasetName.toLowerCase()) {
          dataset = response.data[i];
          break;
        }
      }

      callback(dataset);
    }
  }

  getDataSetById(datasetId, includeLicenses = false) {
    return new Promise((resolve, reject) => {
      smashClient.getDataSetById(datasetId, response => {
        if (response.data.length === 1) {
          const dataset = response.data[0];
          if (includeLicenses) {
            smashClient.GetDatasetLicenses(datasetId, res => {
               // todo: Excluded group licenses until we have proper group license handling request on the server
              dataset.licenses = res.data.filter(l => l.datasetGroup == null) || [];
              resolve(dataset);
            });
          } else {
            resolve(dataset);
          }
        } else {
          reject('Cannot find dataset.');
        }
      });
    });
  }

  GetDatasetByIdWithUsersCreated(datasetId) {
    return new Promise((resolve, reject) => {
      smashClient.GetDatasetByIdWithUsersCreated(datasetId, (response => {
        resolve(response.data[0]);
      }));
    });
  }

  getDataProfileByDatasetId(datasetId, callback) {
    var _this = this;
    smashClient.getDataSetById(datasetId, function (response) {
      _getDataProfileById(response.data[0].dataProfile, callback);
    });
  }

  getDataProfileById(dataProfileId, callback) {
    smashClient.getDataProfileById(dataProfileId, callback);
  }

  getAllDataProfiles(callback) {
    smashClient.getAllDataProfile(callback);
  }


  subscribeDataset(datasetId, datasetLicenseId) {
    return new Promise((resolve, reject) => {
      smashClient.subscribeDataset(datasetId, datasetLicenseId, (response) => {
        if (response.typeId === TYPE_ID.SubscribeDatasetResponse) {
          if (response.status === STATUS.SubscribeDatasetStatus.SUCCESS) {
            resolve(response.datasetSubscription);
          }
        }
        else {
          reject(response);
        }
      });
    });
  }

  checkUserDatasetSubscription(datasetId) {
    return new Promise((resolve, reject) => {
      smashClient.checkUserDatasetSubscription(datasetId, (response) => {
        // todo: server side bug, return type is not an array
        if (!Array.isArray(response.data)) {
          resolve(response.data ? [response.data] : []);
        } else {
          resolve(response.data || []);
        }
      });
    });
  }

  getAccessAuditInDays(start, end, callback) {
    smashClient.GetAccessAuditInDaysByUser(start, end, callback);
  }

  getAccessAuditInMonths(start, end, callback) {
    smashClient.GetAccessAuditInMonthsByUser(start, end, callback);
  }

  getLicenses(datasetId) {
    return new Promise((resolve, reject) => {
      smashClient.GetDatasetLicenses(datasetId, (response) => {
        resolve(response.data);
      });
    });

  }

  createDatasetWidget(datasetId, widgetState, callback) {
    smashClient.createUserDatasetWidget(datasetId, widgetState, callback);
  }

  updateUserDatasetWidget(widgetState, callback) {
    smashClient.updateUserDatasetWidget(widgetState, widgetState, callback);
  }

  findDatasetWidget(datasetId, dataProfileId, callback) {
    return new Promise((resolve, reject) => {
      smashClient.findDatasetWidgetsByUser(datasetId, function (response) {
        if (response.data.length > 0) {

          resolve(response.data[0]);
          // resolve(widgetState);
        } else if (response.data.length === 0) {
          smashClient.findDefaultWidget(dataProfileId, res => {
            if (res.data.length > 0) {
              // remove dataProfile field. only default visualization should have dataProfile field.
              delete res.data[0].dataProfile;

              // replace all dataset ids
              const widgetState = JSON.parse(res.data[0].widgetState);
              widgetState.legends.forEach(legend => {
                Object.keys(legend.mappings).forEach(key => {
                  const map = legend.mappings[key];
                  if (map.datasetId) {
                    map.datasetId = datasetId;
                  }
                })
              });
              res.data[0].widgetState = JSON.stringify(widgetState);

              res.data[0].isDefaultWidget = true;
              resolve(res.data[0]);
            } else {
              resolve(null);
            }
          })
        }
      });
    });
  }

  subscribeDataset(datasetId, datasetLicenseId) {
    return new Promise((resolve, reject) => {
      smashClient.subscribeDataset(datasetId, datasetLicenseId, (response) => {
        if (response.typeId === TYPE_ID.SubscribeDatasetResponse) {
          if (response.status === STATUS.SubscribeDatasetStatus.SUCCESS) {
            resolve(response.datasetSubscription);
          }
        } else {
          reject(response);
        }
      });
    });
  }

  unsubscribeDataset(datasetId, datasetLicenseId) {
    return new Promise((resolve, reject) => {
      smashClient.unsubscribeDataset(datasetId, datasetLicenseId, (response) => {
        if (response.typeId === TYPE_ID.UnsubscribeDatasetResponse) {
          if (response.status === STATUS.SubscribeDatasetStatus.SUCCESS) {
            resolve(response.status);
          }
        }
        else {
          reject(response);
        }
      });
    });
  }

  getDatasetSubscription(datasetId) {
    return new Promise((resolve, reject) => {
      smashClient.checkUserDatasetSubscription(datasetId, response => {
        const subscription = response.data;
        if (subscription) {
          smashClient.GetDatasetLicenses(datasetId, res => {
            const license = res.data.find(license => license.persistenceId === subscription.datasetLicense);
            resolve(license || null);
          });
        } else {
          resolve(null);
        }
      });
    });
  };
}

const instance = new DataSetService();
export default instance;





// WEBPACK FOOTER //
// ./src/core/services/datasetService.js